

(function() {
	var AdminDealerApp = (function() {
		var __private = {
			openPopupButtonClass: "popupOpen",
			popupClass: "dealer-section__popup",

			disabledClass: "disabled",
			openClass    : "open",
			closeClass   : "close",

			listener() {
				document.addEventListener("click", function(event) {
					event = event || window.event;
					var target = event.target;
					var popup = null;

					if(target instanceof HTMLElement && target.classList.contains(__private.openPopupButtonClass)) {
						if(target.nextElementSibling && target.nextElementSibling.classList.contains(__private.popupClass))
							popup = target.nextElementSibling;

						if(popup instanceof HTMLElement) {
							popup.classList.add("open");
							__private.popupListener(popup);
						}
					}
				});
			},

			popupListener(popup) {
				popup.addEventListener("click", popupClickEvent);
				popup.addEventListener("input", popupKeyEvent);

				function popupClickEvent(event) {
					event = event || window.event;

					var target   = event.target;
					var close    = popup.querySelector(`.${__private.closeClass}`);
					var reset    = popup.querySelector("input[type='reset']");
					var submit   = popup.querySelector("input[type='submit']");
					var textarea = popup.querySelector("textarea");

					if(target === close) {
						popup.classList.remove(__private.openClass);
					}

					if(target === reset) {
						textarea.value = "";
						popup.classList.remove(__private.openClass);
					}
				}

				function popupKeyEvent(event) {
					event = event || window.event;
					var textarea = popup.querySelector("textarea");
					var submit   = popup.querySelector("input[type='submit']");

					if(textarea instanceof HTMLTextAreaElement && submit instanceof HTMLInputElement) {
						if(textarea.value.length > 0 && textarea.value !== "" && textarea.value !== " ") {
							submit.disabled = false;
							submit.classList.remove(__private.disabledClass);
						}
						else {
							submit.disabled = true;
							submit.classList.add(__private.disabledClass);
						}
					}
				}
			}
		};

		return {
			popup() {
				__private.listener();
			},

			license() {},

			user() {}
		};
	})();


	document.addEventListener("DOMContentLoaded", function() {
		if(document.getElementById("admin")) {
			AdminDealerApp.popup();
		}
	});
})();